var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8885 0.701385L21.6478 9.2758C21.7892 9.59849 22.0146 9.87731 22.3006 10.0832C22.5865 10.289 22.9224 10.4143 23.2733 10.4461L32.4314 11.2672C33.4676 11.418 33.881 12.6888 33.1297 13.4206L26.2311 19.216C25.6725 19.6852 25.4183 20.4225 25.5719 21.1347L27.5773 30.5219C27.7532 31.5525 26.6723 32.3401 25.7451 31.8514L17.7516 27.1704C17.4501 26.9934 17.1069 26.9001 16.7573 26.9001C16.4078 26.9001 16.0645 26.9934 15.763 27.1704L7.76957 31.8486C6.8451 32.3346 5.76143 31.5497 5.93739 30.5191L7.94273 21.132C8.09355 20.4197 7.84219 19.6824 7.2836 19.2132L0.382185 13.4234C-0.366329 12.6944 0.0470291 11.4208 1.08043 11.27L10.2386 10.4488C10.5894 10.4171 10.9254 10.2918 11.2113 10.086C11.4972 9.88011 11.7226 9.60128 11.8641 9.27859L15.6234 0.704178C16.0898 -0.23426 17.4248 -0.23426 17.8885 0.701385Z",
    fill: "#FDD835"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6148 9.78971L16.978 3.47201C16.9528 3.1201 16.8802 2.51681 17.4444 2.51681C17.8913 2.51681 18.1343 3.44687 18.1343 3.44687L20.0446 8.5189C20.7652 10.4488 20.4692 11.1108 19.7737 11.5018C18.9749 11.9487 17.7963 11.5995 17.6148 9.78971Z",
    fill: "#FFFF8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4937 18.6546L30.9735 14.3786C31.2444 14.1523 31.7332 13.792 31.3422 13.3815C31.0322 13.0575 30.1943 13.5239 30.1943 13.5239L25.3987 15.398C23.9688 15.8923 23.0191 16.6241 22.9354 17.5458C22.8264 18.7747 23.9296 19.7215 25.4937 18.6546Z",
    fill: "#F4B400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.28965c9afd6c2c851eb606cb07667280.svg";
export { ForwardRef as ReactComponent };